import { Box, Button, Paper, Stack, SxProps, Theme, useTheme } from '@mui/material'
import { i18WithDefault as t } from '@shared/locales'
import { Auth } from 'aws-amplify'
import { useFormik } from 'formik'
import React from 'react'
import * as Yup from 'yup'
import { CatIcon, DogIcon } from 'asset'
import { SignInTooltipContent } from './signin_tooltip_content'
import { AuthDialog } from 'auth_dialog'

export type TFormikValues = {
  email: string
  inputCode: boolean
  code: string
}

const petWrapperStyle: SxProps<Theme> = (theme) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 48,
  height: 48,
  borderRadius: 24,
  backgroundColor: theme.palette.primary.shade30,
})

export type ChallengeResponseType = {
  username: string
  answer: string
}

type SignInSignUpProps = {
  onError?: (error: Error) => void
  onSuccessfulSignIn?: () => void
  sx?: SxProps<Theme>
}

export const SignInSignUpTooltip = ({ onError, sx, onSuccessfulSignIn }: SignInSignUpProps) => {
  const theme = useTheme()
  const [isSignUp, setIsSignUp] = React.useState(true)

  const handlePaperClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation()
  }

  const handlePaperTouchEnd = (event: React.TouchEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }

  return (
    <Paper
      elevation={24}
      sx={{ px: 2, py: 3, width: 287, ...sx }}
      onClick={handlePaperClick}
      onTouchEnd={handlePaperTouchEnd}
    >
      <Stack spacing={2}>
        <Stack direction="row" spacing={1} justifyContent="center">
          <Box sx={petWrapperStyle(theme)}>
            <DogIcon viewBox="0 -2 28 28" style={{ color: theme.palette.primary.main }} />
          </Box>
          <Box sx={petWrapperStyle(theme)}>
            <CatIcon viewBox="0 -2 28 28" style={{ color: theme.palette.primary.main }} />
          </Box>
        </Stack>
        {isSignUp ? (
          <>
            <SignInTooltipContent onError={onError} onSuccessfulSignIn={onSuccessfulSignIn} />
            <Button variant="text" onClick={() => setIsSignUp(false)}>
              {t('global.label.signUp')}
            </Button>
          </>
        ) : (
          <>
            <AuthDialog modalStep="signUp" />
            <Button variant="text" onClick={() => setIsSignUp(true)}>
              {t('global.label.signIn')}
            </Button>
          </>
        )}
      </Stack>
    </Paper>
  )
}
